<template>

  <div class="map-view" v-if="!loading">
    <surface :asset-id="asset"></surface>
    <sidebar></sidebar>
  </div>

  <loader v-else></loader>

</template>

<script>

import {mapActions, mapState} from 'vuex'
import initWebsocket from '../_initiators/websocket.es6'
import Surface from './surface/surface'
import Sidebar from './sidebar/sidebar'
import Loader from '@/observer/shared/loader'

export default {
  name: 'map-view',

  data () {
    return {
      loading: true,
      socket: null,
      asset: this.$route.params.assetId
    }
  },

  computed: {
    ...mapState('map', [
      'elements'
    ]),
  },

  methods: {
    ...mapActions('map', [
      'select',
      'initialize'
    ]),
  },

  async created () {
    await this.initialize()

    // TODO: initialize and manage globally in application
    this.socket = initWebsocket({ vm: this, hostname: this.$hostname })
    this.loading = false
  },

  beforeDestroy () {
    this.socket.close()
  },

  components: {
    Loader,
    Surface,
    Sidebar
  }
}

</script>

<style scoped lang="scss">

  @import '../../assets/responsive';

  .map-view {
    display: flex;
    flex-direction: row;
    height: 100%;
    align-items: stretch;

    @include media('<tablet') {
      display: block;
    }
  }

</style>
